(function () {
  const UNIT_PER_MQ = 100; // 1 unità = 0,01 mq
  const MIN_MQ_SURCHARGE = 5;      // soglia
  const SURCHARGE_PCT = 20;        // +20%
  const SBANCALAMENTO_CENTS = 1500; // 15€

  function moneyFromCents(cents, locale = document.documentElement.lang || 'it-IT') {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const value = cents / 100;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
    } catch {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  function getRoot() {
    return document.getElementById('tile-calculator');
  }

  function getVariantIdFromForm() {
    const idInput =
      document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function getVariantsData() {
    const el = document.getElementById('tc_variants');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '[]');
    } catch {
      return null;
    }
  }

  function updateRootVariantDataFromDOM() {
    const root = getRoot();
    if (!root) return;

    const variantId = getVariantIdFromForm();
    if (variantId) root.dataset.variantId = String(variantId);

    // PRIMA scelta: dati dal JSON (robusto e preciso)
    const variants = getVariantsData();
    if (variants && variantId) {
      const v = variants.find((x) => Number(x.id) === Number(variantId));
      if (v) {
        if (typeof v.price === 'number') root.dataset.priceCentsPerUnit = String(v.price);
        if (typeof v.area_per_pezzo_mq === 'number') root.dataset.areaPerPezzoMq = String(v.area_per_pezzo_mq);
        return;
      }
    }

    // FALLBACK: leggi prezzo dal DOM
    const priceEl =
      document.querySelector('[data-product-price]') ||
      document.querySelector('.price__regular .price-item--regular') ||
      document.querySelector('.price-item--regular') ||
      document.querySelector('[data-testid="price"]');

    if (priceEl) {
      const txt = (priceEl.textContent || '').trim();
      const normalized = txt
        .replace(/\s/g, '')
        .replace(/[^\d,.-]/g, '')
        .replace(/\.(?=\d{3})/g, '')
        .replace(',', '.');
      const val = parseFloat(normalized);
      if (!Number.isNaN(val)) root.dataset.priceCentsPerUnit = String(Math.round(val * 100));
    }
  }

  function ensureQuantityHiddenInput() {
  const form =
    document.querySelector('product-form form[action^="/cart/add"]') ||
    document.querySelector('form[action^="/cart/add"]');

  if (!form) return null;

  let q = form.querySelector('input[name="quantity"][data-tc="1"]');
  if (!q) {
    q = document.createElement('input');
    q.type = 'hidden';
    q.name = 'quantity';
    q.setAttribute('data-tc', '1');
    form.appendChild(q);
  }
  return q;
}

  function syncShopifyQuantityInput(qty) {
    const hidden = ensureQuantityHiddenInput();
    if (hidden) hidden.value = String(qty);

    const form =
      document.querySelector('product-form form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');

    if (!form) return;

    // Se il tema ha anche un input quantity "visibile", aggiorniamo pure quello
    const qInput = form.querySelector('input[name="quantity"]:not([data-tc="1"])');
    if (qInput) {
      qInput.value = String(qty);
      qInput.dispatchEvent(new Event('input', { bubbles: true }));
      qInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function bindForceQtyOnSubmit() {
    ensureQuantityHiddenInput();

    const form =
      document.querySelector('product-form form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');

    if (!form || form.dataset.tcBound === '1') return;
    form.dataset.tcBound = '1';

    // FORZA QTY PRIMA CHE SHOPIFY LEGGA IL FORM
    form.addEventListener(
      'submit',
      () => {
        updateRootVariantDataFromDOM();
        calcAndRender();

        // qty “tecnica” già sincronizzata, ma faccio hard-set finale
        const hidden = form.querySelector('input[name="quantity"][data-tc="1"]');
        if (!hidden) return;

        // niente: calcAndRender() ha già impostato hidden.value
      },
      true
    );

    // TRACK CAMBIO VARIANTE (Horizon-proof)
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    idInput.addEventListener('change', () => {
      updateRootVariantDataFromDOM();
      calcAndRender();
    });

    const obs = new MutationObserver(() => {
      updateRootVariantDataFromDOM();
      calcAndRender();
    });
    obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });

    let last = idInput.value;
    setInterval(() => {
      if (idInput.value !== last) {
        last = idInput.value;
        updateRootVariantDataFromDOM();
        calcAndRender();
      }
    }, 250);


    
  }

  function ceilSafe(x) {
    // se è praticamente un intero, non salire
    const eps = 1e-9;
    return Math.ceil(x - eps);
  }

  function calcAndRender() {
    const root = getRoot();
    if (!root) return;

    const modeEl = document.getElementById('tc_mode');
    const valueEl = document.getElementById('tc_value');
    const wasteEl = document.getElementById('tc_waste');

    const mqEffEl = document.getElementById('tc_mq_eff');
    const piecesEl = document.getElementById('tc_pieces');
    const qtyEl = document.getElementById('tc_qty'); // può essere hidden
    const totalEl = document.getElementById('tc_total');
    const valueLabel = document.getElementById('tc_value_label');

    if (!modeEl || !valueEl || !wasteEl || !mqEffEl || !piecesEl || !totalEl) return;

    const mode = modeEl.value;

    // UX: quando passo a "pezzi" voglio input da interi
    if (mode === 'pz') {
      if (valueLabel) valueLabel.textContent = 'Pezzi (piastrelle)';
      valueEl.step = '1';
    } else {
      if (valueLabel) valueLabel.textContent = 'Metri quadri';
      valueEl.step = '0.01';
    }

    const areaPerPiece = parseFloat(root.dataset.areaPerPezzoMq || '0');
    const priceCentsPerUnit = parseInt(root.dataset.priceCentsPerUnit || '0', 10);
    const sfridoDefault = parseFloat(root.dataset.sfridoDefault || '10');

    const raw = parseFloat(valueEl.value || '0');
    if (!raw || raw <= 0) {
      mqEffEl.textContent = '–';
      piecesEl.textContent = '–';
      if (qtyEl) qtyEl.textContent = '–';
      totalEl.textContent = '–';
      return;
    }

    const wastePct = wasteEl.checked ? (Number.isFinite(sfridoDefault) ? sfridoDefault : 10) : 0;

    // ... dopo aver ottenuto areaPerPiece, wastePct, raw, ecc.

    let mqBase = 0;
    let piecesBase = 0;

    if (mode === 'mq') {
      mqBase = raw;
      if (areaPerPiece > 0) piecesBase = ceilSafe(mqBase / areaPerPiece);
    } else {
      piecesBase = Math.ceil(raw);
      if (areaPerPiece > 0) mqBase = piecesBase * areaPerPiece;
    }

    // applico sfrido ai mq
    const mqEff = mqBase * (1 + wastePct / 100);

    // pezzi “effettivi”: se aumenta la superficie, aumentano anche i pezzi
    let piecesEff = piecesBase;
    if (areaPerPiece > 0) {
      piecesEff = ceilSafe(mqEff / areaPerPiece);
    }

        // === QTY FATTURATA ===
        // base unità tecniche (0,01 mq)
        const baseQty = Math.ceil(mqEff * UNIT_PER_MQ);

        // regola: sotto 5mq => +20% (sulla fatturazione, non sui mq)
            const applyMinOrderRule = mqEff < MIN_MQ_SURCHARGE;

        // +20% SOLO sotto 5mq (sulla fatturazione, non sui mq)
        const surchargeMultiplier = applyMinOrderRule ? (1 + SURCHARGE_PCT / 100) : 1;
        let billingQty = Math.ceil(baseQty * surchargeMultiplier);

        // +15€ SOLO sotto 5mq (convertito in unità prezzo variante)
        let sbancalamentoUnits = 0;
        if (applyMinOrderRule && priceCentsPerUnit > 0) {
          sbancalamentoUnits = Math.ceil(SBANCALAMENTO_CENTS / priceCentsPerUnit);
          billingQty += sbancalamentoUnits;
        }

        mqEffEl.textContent = mqEff.toFixed(2);
        piecesEl.textContent = String(piecesEff || '-');
        if (qtyEl) qtyEl.textContent = String(billingQty);

        if (priceCentsPerUnit > 0) {
          totalEl.textContent = moneyFromCents(priceCentsPerUnit * billingQty);
        } else {
          totalEl.textContent = '-';
        }

        // invio a Shopify la quantity fatturata
        syncShopifyQuantityInput(billingQty);

        // proprietà riga (leggibili in carrello/ordine)
        syncLineItemProperties(piecesEff, mqEff, applyMinOrderRule, sbancalamentoUnits);
  }

  function ensurePropertyInput(name) {
    const form =
      document.querySelector('product-form form[action^="/cart/add"]') ||
      document.querySelector('form[action^="/cart/add"]');
    if (!form) return null;

    let el = form.querySelector(`input[name="${CSS.escape(name)}"][data-tc="1"]`);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-tc', '1');
      form.appendChild(el);
    }
    return el;
  }

    function syncLineItemProperties(pieces, mqEff, applySurcharge, sbancalamentoUnits) {
      const p1 = ensurePropertyInput('properties[Numero pezzi]');
      const p2 = ensurePropertyInput('properties[Metri quadrati]');

      if (p1) p1.value = String(pieces || '');
      if (p2) p2.value = mqEff ? Number(mqEff).toFixed(2) : '';
      }

  function bind() {
    const root = getRoot();
    if (!root) return;

    bindForceQtyOnSubmit();

    updateRootVariantDataFromDOM();
    calcAndRender();

    document.getElementById('tc_mode')?.addEventListener('change', calcAndRender);
    document.getElementById('tc_value')?.addEventListener('input', calcAndRender);
    document.getElementById('tc_waste')?.addEventListener('change', calcAndRender);

    // Cambi variante (Horizon usa eventi + change sul form)
    document.addEventListener('variant:change', () => {
      updateRootVariantDataFromDOM();
      calcAndRender();
    });

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;
      if (t.name === 'id') {
        updateRootVariantDataFromDOM();
        calcAndRender();
      }
    });

    
  }

  document.addEventListener('DOMContentLoaded', bind);
})();